import styled from "styled-components";

export const ReferBock = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  .pic {
    width: 198px;
    height: 134px;
    object-fit: contain;
    margin: 0 auto;
  }
  .headerL {
    white-space: nowrap;
  }
  .full-width {
    width: 100%;
  }
  .referral-link {
    background: #392c19;
  }
  .copylink {
    width: 100%;
    max-width: calc(100vw - 48px);
    color: white;
  }

  @media (min-width: 1024px) {
    max-width: 1056px;
    margin: 0 auto;
    display: grid;
    gap: 0 48px;
    grid-template-columns: 476px 1fr;
    .title {
      text-align: left;
    }
  }
  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;

export const RankingBlock = styled.div<{ $withButton?: boolean }>`
  padding: ${({ $withButton }) =>
    $withButton ? "48px 24px 24px" : "48px 24px"};
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
  border-radius: var(--rounding-radius-xxl, 32px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));

  @media (max-width: 1024px) {
    padding: 32px 24px;
  }
`;

export const RankingTops = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
`;

export const RankingUnit = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  .coin {
    width: 48px;
    height: 48px;
  }
`;
